import React, { useRef, useState, useEffect } from 'react';
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';
import PrintFile from '../../ListView/Templates/ActionsTemplate/PrintFile';
import FileDownload from '../../ListView/Templates/ActionsTemplate/FileDownload';
import { getDisplayableImageUrl, isHeicFile } from 'utils/heicUtils';

const ImageViewer = (props) => {
  const { imageUrl, title, onLoad, item } = props;
  const imageRef = useRef();
  const [displayUrl, setDisplayUrl] = useState(imageUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      if (imageUrl && item?.display_name && isHeicFile(item.display_name)) {
        setIsLoading(true);
        setError(null);
        try {
          const convertedUrl = await getDisplayableImageUrl(imageUrl, item.display_name);
          setDisplayUrl(convertedUrl);
        } catch (err) {
          console.error('Failed to convert HEIC image:', err);
          setError('Failed to load HEIC image. Please try downloading the file.');
          setDisplayUrl(imageUrl); // Fallback to original URL
        } finally {
          setIsLoading(false);
        }
      } else {
        setDisplayUrl(imageUrl);
      }
    };

    loadImage();
  }, [imageUrl, item?.display_name]);

  const Controls = () => {
    const { zoomIn, zoomOut } = useControls();
    return (
      <div className="zoom-controls">
        <i className="icon-zoom-out p-2 pointer float-end h2 mb-0" title="Zoom Out" onClick={() => zoomOut()} />
        <i className="icon-zoom-in p-2 pointer float-end h2 mb-0" title="Zoom In" onClick={() => zoomIn()} />

        <FileDownload
          rowData={item}
          isFromFilePreviewModal={true}
          filePreviewModalIconClassName={'icon-save p-2 pointer float-end h2 mb-0'}
        />
        <PrintFile
          rowData={item}
          isFromFilePreviewModal={true}
          filePreviewModalIconClassName={'icon-Print p-2 pointer float-end h2 mb-0'}
          imageRef={imageRef}
        />
      </div>
    );
  };

  return (
    <>
      {error && (
        <div className="error-message text-center p-3">
          <p className="text-danger">{error}</p>
        </div>
      )}
      {isLoading ? (
        <div className="loading-container d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Converting HEIC image...</span>
          </div>
          <span className="ms-2">Converting HEIC image...</span>
        </div>
      ) : (
        <TransformWrapper minScale={0.3}>
          <Controls />
          <TransformComponent>
            <div className="image-comp">
              <img
                ref={imageRef}
                src={displayUrl}
                alt={title}
                controls
                onLoad={typeof onLoad === 'function' && onLoad}
                onError={() => setError('Failed to load image')}
              />
            </div>
          </TransformComponent>
        </TransformWrapper>
      )}
    </>
  );
};

export default ImageViewer;
